// extracted by mini-css-extract-plugin
export default {"tooltiplink":"index_tooltiplink__p+ktb"};